// frontend/src/components/LaborRates/RateDiffPrompt.tsx
import React from 'react';
import { Modal } from 'antd';

export function RateDiffPrompt(props: {
  open: boolean;
  savedRate: number;
  currentRate: number;
  onKeep: () => void;
  onUpdate: () => void;
}) {
  const { open, savedRate, currentRate, onKeep, onUpdate } = props;
  return (
    <Modal
      open={open}
      centered
      title="Labor rate changed"
      okText={`Use current $${currentRate}/hr`}
      cancelText={`Keep saved $${savedRate}/hr`}
      onOk={onUpdate}
      onCancel={onKeep}
    >
      This template was saved at ${savedRate.toFixed(2)}/hr. The current rate is ${currentRate.toFixed(2)}/hr.
    </Modal>
  );
}
